module.exports = __webpack_public_path__ + "img/dm.2910f70.svg";